import { FC } from "react";
import parse from "html-react-parser";
import ModalBoxCore from "../../core-components/modal-box/ModalBoxCore";
import ModalHeader from "../../core-components/modal-box/modal-header/ModalHeader";
import ModalBody from "../../core-components/modal-box/modal-body/ModalBody";
import ModalFooter from "../../core-components/modal-box/modal-footer/ModalFooter";
import ExclamationMarkSvg from "../../../assets/svg-fc/ExclamationMarkSvg";
import "./joinWhatsAppGroupModal.css";

interface IChatOnWhatsAppModal {
	openWhatsAppModal: boolean;
	heading: string;
	subheading?: string;
	middleText?: string;
	endingText?: string;
	buttonText: string;
	disclaimer?: string;
	closeModal: () => void;
	onClickJoinWhatsApp: () => void;
}

const JoinWhatsAppGroupModal: FC<IChatOnWhatsAppModal> = ({
	openWhatsAppModal,
	closeModal,
	buttonText,
	endingText,
	heading,
	middleText,
	subheading,
	disclaimer,
	onClickJoinWhatsApp,
}) => {
	return (
		<ModalBoxCore open={openWhatsAppModal} onClose={closeModal} className="joinWhatsAppGroupModal">
			<ModalHeader
				className="whatsAppModalHeader"
				modalHeaderText={heading}
				closeModal={() => {
					closeModal();
				}}
			/>
			<ModalBody className="whatsAppModalBody">
				<p className="text-center text-[16px]">{subheading || ""}</p>

				{middleText && (
					<div className="middleTextContainer">
						<p>‘{middleText}’</p>
					</div>
				)}

				<p className="endingText">{parse(endingText || "")}</p>

				{disclaimer && (
					<div className="multiplePhoneNumbersBox">
						<ExclamationMarkSvg />
						<p>{disclaimer}</p>
					</div>
				)}
			</ModalBody>
			<ModalFooter
				modalFooterClassName="whatsAppModalFooter"
				className="whatsAppModalFooterBtn"
				buttonText={buttonText || ""}
				onclick={() => {
					onClickJoinWhatsApp();
				}}
			/>
		</ModalBoxCore>
	);
};
export default JoinWhatsAppGroupModal;
